import { Provider } from '@angular/core';
import { FIREBASE_AUTH } from '@hmax-order/frontend/utils';
import { initializeApp } from 'firebase/app';
import { browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth';
import { environment } from '../../../environments/environment';

/**
 * Provider da instância do Firebase Auth (usado no login opcional com conta Google).
 *
 * Substitui `provideFirebaseApp`/`provideAuth` do @angular/fire pelo SDK `firebase`
 * puro. Inicializa o Firebase App e o Auth e garante a persistência local da sessão
 * Google, necessária para a renovação silenciosa do JWT da HMAX (evita ter que logar
 * novamente todo dia). A definição de persistência não bloqueia a inicialização: o
 * erro é apenas silenciado.
 */
export function provideFirebase(): Provider {
  return {
    provide: FIREBASE_AUTH,
    useFactory: () => {
      const app = initializeApp(environment.firebase);
      const auth = getAuth(app);
      setPersistence(auth, browserLocalPersistence).catch(() => undefined);
      return auth;
    },
  };
}
